import { useEffect, useState } from "react";
import { api } from "../../api/client";
import { Modal } from "../../components/ui/Modal";
import { Spinner, EmptyState } from "../../components/ui/Spinner";
import { formatDateTime } from "../../utils/formatDate";
import type { AuditLogEntry, UserListItem } from "../../types";

export function UserActivityModal({ user, onClose }: { user: UserListItem; onClose: () => void }) {
  const [activity, setActivity] = useState<AuditLogEntry[] | null>(null);

  useEffect(() => {
    api.get<AuditLogEntry[]>(`/api/users/${user.id}/activity`).then(setActivity);
  }, [user.id]);

  return (
    <Modal title={`Letzte Aktivitäten: ${user.full_name}`} onClose={onClose} size="lg">
      {!activity ? <Spinner /> : activity.length === 0 ? <EmptyState message="Keine Aktivitäten vorhanden." /> : (
        <ul className="space-y-3 max-h-96 overflow-y-auto">
          {activity.map((entry) => (
            <li key={entry.id} className="text-sm border-b border-surface-border/60 pb-2">
              <p className="text-gray-300">{entry.description}</p>
              <p className="text-xs text-gray-500 mt-0.5">{formatDateTime(entry.created_at)}</p>
            </li>
          ))}
        </ul>
      )}
    </Modal>
  );
}
